module.exports = __webpack_public_path__ + "static/media/epic-mobile-media-image.952e16b2.png";